export const ELEMENTS = [
  { id: 'hq', label: 'HQ', call: 'WF-HQ' },
  { id: 'team1', label: 'Team 1', call: 'WF-1' },
  { id: 'team2', label: 'Team 2', call: 'WF-2' },
  { id: 'team3', label: 'Team 3', call: 'WF-3' },
  { id: 'team4', label: 'Team 4', call: '' },
  { id: 'enablers', label: 'Enablers', call: 'WF-E' },
] as const;

export type ElementId = (typeof ELEMENTS)[number]['id'];

export const AAR_ELEMENTS = [
  { id: 'rs', label: 'R&S Section' },
  { id: 'smb', label: 'SMB' },
  { id: 'eotg', label: 'EOTG' },
  { id: 'students', label: 'Students' },
  { id: 'external', label: 'External' },
  { id: 'other', label: 'Other' },
] as const;

export type AarElementId = (typeof AAR_ELEMENTS)[number]['id'];

export function aarElementLabel(id: string): string {
  return AAR_ELEMENTS.find((item) => item.id === id)?.label || id;
}

export function aarElementsLabel(ids: string[] | undefined, fallback = ''): string {
  const list = (ids || []).filter(Boolean);
  if (!list.length && fallback) return aarElementLabel(fallback);
  return list.map((id) => aarElementLabel(id)).join(' · ');
}

export const BILLETS = [
  'PltCmdr',
  'PltSgt',
  'A/PltSgt',
  'SENCO',
  'CommChief',
  'IntChief',
  'SARC',
  'TL',
  'ATL',
  'RTO',
  'A/RTO',
  'Point',
  'Scout',
  'RRT',
  'EOD',
  'CI',
  'Para',
  'Boats',
  'Inbound',
] as const;

/** Chip label is what the walker taps. Full label is the board and the workbook. */
export const CATEGORIES = [
  { id: 'roc_c2', chip: 'ROC / C2', label: 'Recon Operations Center / C2' },
  { id: 'orp_c2', chip: 'ORP / C2', label: 'Objective Rally Point / C2' },
  { id: 'patrolling', chip: 'Patrolling', label: 'Patrolling' },
  { id: 'hide_site', chip: 'Hide site', label: 'Hide Site' },
  { id: 'linkups', chip: 'Linkups', label: 'Linkups' },
  { id: 'communications', chip: 'Communications', label: 'Communications' },
  { id: 'security', chip: 'Security', label: 'Security' },
  { id: 'contingencies', chip: 'Contingencies', label: 'Contingencies' },
  { id: 'casualty_care', chip: 'Casualty care', label: 'Casualty Care' },
  { id: 'equipment', chip: 'Equipment', label: 'Mission Essential Equipment' },
  { id: 'mindset', chip: 'Mindset', label: 'Mindset / Attitude' },
  { id: 'incident', chip: 'Incident', label: 'Incident report' },
  { id: 'other', chip: 'Other', label: 'Other' },
] as const;

export type CategoryId = (typeof CATEGORIES)[number]['id'];
export type Role = 'instructor' | 'admin';

export const SCORE_LEGEND =
  '1 Critical · 2 Deficient · 3 Capable · 4 Proficient · 5 Outstanding · N/A if you did not see it';

export function elementLabel(id: string): string {
  return ELEMENTS.find((e) => e.id === id)?.label || id;
}

export function elementsLabel(ids: string[] | undefined, fallback = ''): string {
  const list = (ids || []).filter(Boolean);
  if (!list.length && fallback) return elementLabel(fallback);
  return list.map((id) => elementLabel(id)).join(' · ');
}

/** Roster section title. Chips stay on the short label. */
export function elementHeading(id: string): string {
  const element = ELEMENTS.find((e) => e.id === id);
  if (!element) return id;
  return element.call ? `${element.label} · ${element.call}` : element.label;
}

export function categoryLabel(id: string): string {
  return CATEGORIES.find((c) => c.id === id)?.label || id;
}

export function categoryChip(id: string): string {
  return CATEGORIES.find((c) => c.id === id)?.chip || id;
}

export function isElement(id: string): id is ElementId {
  return ELEMENTS.some((e) => e.id === id);
}

export function isCategory(id: string): id is CategoryId {
  return CATEGORIES.some((c) => c.id === id);
}

export function isBillet(id: string): boolean {
  return (BILLETS as readonly string[]).includes(id);
}

export function isRole(id: string): id is Role {
  return id === 'instructor' || id === 'admin';
}

export interface TargetPayload {
  tokens: string[];
  labels: string[];
  snapshot: string[];
}

export function emptyTargets(): TargetPayload {
  return { tokens: [], labels: [], snapshot: [] };
}

export function allToken(element: string): string {
  return `all:${element}`;
}

export function personToken(id: string): string {
  return `person:${id}`;
}

export function targetSummary(t: TargetPayload | null | undefined): string {
  if (!t) return '';
  if (t.labels.length) return t.labels.join(' · ');
  if (t.snapshot.length) return t.snapshot.join(' · ');
  return '';
}
